import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { MapDialogComponent } from './map-dialog.component';
import { AngularMaterialModule } from '../../shared/module/angular-material.module';
@NgModule({
    declarations: [MapDialogComponent],
    imports: [
        CommonModule,
        GoogleMapsModule,
        AngularMaterialModule
    ],
    exports: [MapDialogComponent]
})
export class MapDialogModule { }